import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { IoIosArrowUp } from "react-icons/io";
import resetBtn from "../../assets/images/reset-arrow.svg";
import downloadBtn from "../../assets/images/filter-download-btn.svg";
import {
  getAllJobApplications,
  deleteJobAPllicationById,
} from "../../actions/jobApplicationAction";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
import DataTable, { createTheme } from "react-data-table-component";
import InitializeLocalStorage from "../../components/PaginationHandle";

createTheme(
  "solarized",
  {
    text: {
      primary: "#000",
      secondary: "#000",
    },
    background: {
      default: "#fff",
    },
    context: {
      background: "#cb4b16",
      text: "#FFFFFF",
    },
    divider: {
      default: "#DFE0EB",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  },
  "dark"
);

const JobApplications = () => {
  const [applications, setApplications] = useState([]);
  const [loader, setLoader] = useState(false);
  const { admin } = useSelector((state) => state.admin);
  const currentUserRole = admin.role;
  const [getDelete, setDelete] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [selectedOption, setSelectedOption] = useState();
  const [filteredItems, setFilteredItems] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [isFilterOpen, setIsFilterOpen] = useState(true);

  const location = useLocation();
  const { pathname } = location;

  InitializeLocalStorage(pathname, localStorage.getItem("currentURL"));

  const deleteApplication = async (id) => {
    try {
      const response = await deleteJobAPllicationById(id);
      if (response.data.success) {
        toast.success(response.data.message);
        getAllApplicationUsers();
      }
    } catch (error) {}
  };

  const getAllApplicationUsers = async () => {
    setLoader(true);
    let res = await getAllJobApplications();
    if (res?.data?.data?.response) {
      setApplications(res?.data?.data?.response);
    }
    setLoader(false);
  };

  useEffect(() => {
    getAllApplicationUsers();
  }, []);

  const caseInsensitiveSort = (rowA, rowB, columnId) => {
    const getProperty = (row, columnId) => {
      switch (columnId) {
        case "Applicant Name":
          return (row?.firstName + " " + row?.lastName).toLowerCase() || "";

        case "Email":
          return row?.email?.toLowerCase() || "";

        case "Phone":
          return row?.phone || "";
        case "State":
          return row?.state?.toLowerCase() || "";
        case "Specialty":
          return row?.specialty?.toLowerCase() || "";
        case "Interest":
          return row?.interest?.toLowerCase() || "";
        case "Information":
          return row?.information?.toLowerCase() || "";

        case "Status":
          return row?.status || "";

        case "Created At":
          const endDate = new Date(row?.createdAt);
          return `${
            endDate.getMonth() + 1
          }/${endDate.getDate()}/${endDate.getFullYear()}`.toLowerCase();

        default:
          return "";
      }
    };

    const a = getProperty(rowA, columnId);
    const b = getProperty(rowB, columnId);

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  const columns = [
    {
      name: "Applicant Name",
      selector: (row) => row?.firstName + " " + row?.lastName,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Applicant Name"),
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Email"),
    },
    {
      name: "Phone",
      selector: (row) => row?.phone,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Phone"),
    },
    {
      name: "State",
      selector: (row) => row?.state,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "State"),
    },
    {
      name: "Specialty",
      selector: (row) => row?.specialty,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Specialty"),
    },
    {
      name: "Interest",
      selector: (row) => row?.interest,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Interest"),
    },
    {
      name: "Information",
      selector: (row) => row?.information,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Information"),

      maxWidth: "600px",
    },
    {
      name: "Created At",
      selector: (row) => {
        const options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        };

        const date = new Date(row?.createdAt);
        return date.toLocaleDateString(undefined, options).replace(/\//g, "-");
      },
      minWidth: "220px",
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Created At"),
    },

    {
      name: "Actions",
      selector: (row) => (
        <>
          <div className="td-actions table-actions-btns">
            <ul className="list-unstyled mb-0 d-flex justify-content-center">
              {currentUserRole?.viewJobApplication ? (
                !(
                  row?.username === admin?.username ||
                  row?.role?.title == "super admin"
                ) ? (
                  <li className="d-inline-block align-top">
                    <OverlayTrigger
                      overlay={<Tooltip id="tooltip-436082023">Edit</Tooltip>}
                      placement="left"
                    >
                      <Link
                        to={`/view-job-application/${row._id}`}
                        type="button"
                        className="btn-link btn-icon btn btn-success"
                      >
                        <FaEye />
                      </Link>
                    </OverlayTrigger>
                  </li>
                ) : (
                  <li className="d-inline-block align-top">
                    <OverlayTrigger
                      overlay={<Tooltip id="tooltip-436082023">Edit</Tooltip>}
                      placement="left"
                    >
                      <span
                        className="btn-link btn-icon btn btn-success "
                        disabled
                      >
                        <FaEye />
                      </span>
                    </OverlayTrigger>
                  </li>
                )
              ) : (
                <button
                  type="button"
                  className="btn-link btn-icon btn btn-success disabled"
                  disabled
                >
                  <FaEdit />
                </button>
              )}

              {currentUserRole?.deleteJobApplication ? (
                !(
                  row?.username === admin?.username ||
                  row?.role?.title == "super admin"
                ) ? (
                  <li className="d-inline-block align-top">
                    <OverlayTrigger
                      overlay={<Tooltip id="tooltip-436082023">Delete</Tooltip>}
                      placement="left"
                    >
                      <button
                        onClick={() => deleteApplication(row._id)}
                        type="button"
                        className="btn-link btn-icon btn btn-danger"
                      >
                        <FaTrash />
                      </button>
                    </OverlayTrigger>
                  </li>
                ) : (
                  <li className="d-inline-block align-top">
                    <OverlayTrigger
                      overlay={<Tooltip id="tooltip-436082023">Delete</Tooltip>}
                      placement="left"
                    >
                      <button
                        type="button"
                        className="btn-link btn-icon btn btn-danger disabled"
                        disabled
                      >
                        <FaTrash />
                      </button>
                    </OverlayTrigger>
                  </li>
                )
              ) : (
                <button
                  type="button"
                  className="btn-link btn-icon btn btn-success disabled"
                  disabled
                >
                  <FaTrash />
                </button>
              )}
            </ul>
          </div>
        </>
      ),
      sortable: false,
      minWidth: "220px",
    },
  ];

  const filterDatatable = (text) => {
    setFilterText(text);
    filterSearchDatatable(selectedOption, text);
  };

  const filterSearchDatatable = (text, searchText) => {
    const filteredItemsResult = applications.filter((data) => {
      const name = `${data?.firstName} ${data?.lastName}`;
      if (text) {
        if (
          data.status.toString().toLowerCase().includes(text.toLowerCase()) &&
          (name?.toLowerCase().includes(searchText.toLowerCase()) ||
            data?.email.toLowerCase().includes(searchText.toLowerCase()))
        ) {
          return data;
        }
      } else if (
        name?.toLowerCase().includes(searchText.toLowerCase()) ||
        data?.email.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return data;
      }
      return undefined;
    });
    setFilteredItems([...filteredItemsResult]);
    setSelectedOption(text);
  };

  const resetFilter = () => {
    setFilterText("");
    setFilteredItems([...applications]);
    setSelectedOption("");
  };

  const toggleFilterAccordion = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  useEffect(() => {
    if (applications) {
      setFilteredItems([...applications]);
    }
  }, [applications]);

  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 job-form-admin-table">
          <Container fluid>
            <Row>
              {/* Start of filter container */}
              <Col md="12">
                <Card className="filter-card card">
                  <Card.Header 
                    style={{ cursor: "pointer" }}
                    onClick={toggleFilterAccordion}
                  >
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Filter
                      </Card.Title>
                      <div 
                        style={{ 
                          transform: isFilterOpen ? "rotate(0deg)" : "rotate(180deg)",
                          transition: "transform 0.3s ease"
                        }}
                      >
                        <IoIosArrowUp />
                      </div>
                    </div>
                     
                  </Card.Header>
                  {isFilterOpen && (
                  <Card.Body>
                    <Row>
                      <Col xl={4} sm={6} className="search-wrap">
                        <Form.Group>
                          <Form.Label className="d-block mb-2 text-white">
                            Search with Name...
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="search"
                            placeholder="Search"
                            value={filterText}
                            onChange={(e) => filterDatatable(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      {/* <Col xl={4} sm={6} className="search-wrap">
                        <Form.Group>
                          <Form.Label className="d-block mb-2 text-white">
                            Filter with status...
                          </Form.Label>
                          <select
                            value={selectedOption}
                            onChange={(e) =>
                              filterSearchDatatable(e.target.value, filterText)
                            }
                          >
                            <option value="">Select Status</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                          </select>
                        </Form.Group>
                      </Col> */}
                      <Col xl={4} md={6}>
                        <Form.Group>
                          <label className="d-none d-sm-block mb-2 form-label">
                            &nbsp;
                          </label>
                          <div className="d-flex  filter-btns-holder">
                            <button
                              type="button"
                              className="outline-button filter-reset-btn"
                              onClick={() => resetFilter()}
                            >
                              <img src={resetBtn} className="img-fluid mr-3" alt="logo"/>
                              Reset
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                  )}
                </Card>
                {/* End of filled container */}

                {/* Start of table for medical type */}
                <div className="datatable-title card d-flex flex-row justify-content-between align-items-center mb-0">
                  <h4 className="card-title">Job Applications</h4>
                </div>
                 <div className="custom-datatable-pagination">
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  theme="solarized"
                  pagination
                  className="react-datatable"
                />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default JobApplications;
